module.exports = __webpack_public_path__ + "static/media/Coin.8cbb8d70.svg";